import React from 'react';
import {BaseFilterProps} from './interface';
import {ReportingBaseFilter} from './base-filter';

interface QuestionsFilterProps extends BaseFilterProps {}
export const ReportingQuestionsFilter = ({...rest}: QuestionsFilterProps) => {
  return <ReportingBaseFilter {...rest}></ReportingBaseFilter>;
};
